import React from 'react';
import type { AlertProps } from '@mui/material';
import { Alert as MuiAlert, AlertTitle, IconButton } from '@mui/material';
import { SystemIcon } from '@monorepo/nova-icons';
import { AlertComponentProps } from './types';

export const Alert: React.FC<AlertProps & AlertComponentProps> = ({
  severity,
  title,
  message,
  showCloseButton = true,
  action,
  onClose,
  children,
  ...props
}) => {
  const getIcon = () => {
    switch (severity) {
      case 'success':
        return <SystemIcon iconName="Check" />;
      case 'error':
        return <SystemIcon iconName="SealWarning" />;
      case 'info':
        return <SystemIcon iconName="SealQuestion" />;
      default:
        return <SystemIcon iconName="SealQuestion" />;
    }
  };

  const getAction = () => {
    if (action) {
      return action;
    }

    if (showCloseButton && onClose) {
      return (
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={onClose}
        >
          <SystemIcon iconName="X" />
        </IconButton>
      );
    }

    return undefined;
  };

  return (
    <MuiAlert
      severity={severity}
      icon={getIcon()}
      action={getAction()}
      {...props}
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {message}
      {children}
    </MuiAlert>
  );
};
